import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getTermsVersion } from '../../../services/http-terms';
import { updateUser } from '../../../services/http-user';
import { useAuth0 } from '../../Auth0/AuthWrapper';

export default function Terms() {
    const [checked, setChecked] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [termsUrl, setTermsUrl] = useState<string>();
    const [termsVersion, setTermsVersion] = useState<string>("");
    const history = useHistory();
    const {user} = useAuth0();

    async function getTerms () {
        const { version } = await getTermsVersion();
        setTermsVersion(version);
    }

    useEffect(() => {
        getTerms();
    }, []);

    useEffect(() => {
        setTermsUrl(`${process.env.PUBLIC_URL}/EULA/${termsVersion}.html`)
    }, [termsVersion])

    return <div style={{paddingRight: 240}}>
        <Typography style={{paddingBottom: 16}} component="h1" variant="h4">End User Licence Agreement</Typography>
        {termsUrl && <iframe style={{    
            width: "100%",
            border: "none",
            height: 500
            }
        } title="EULA" src={termsUrl} />}
        <div style={{display: 'flex', paddingBottom: 200}}>
            <FormControlLabel 
            label="I have read and accept the end user licence agreement" 
            control={<Checkbox checked={checked} onChange={(e) => {setChecked(!checked)}} />} />

            <Button color="primary" disabled={!checked || updating} variant="outlined" onClick={() => {
                setUpdating(true);
                updateUser(user.sub, {user_metadata: {
                    terms: {
                    dateAccepted: moment().format("YYYY-MM-DD"),
                    version: termsVersion
                }}}).then(() => {
                    history.push("/")
                }).finally(() => {
                    setUpdating(false)
                })

            }}>Continue</Button>
        </div>
    </div>
}